import * as React from 'react';

export default function ShieldCheck({
  viewBox = '0 0 12.8 13.1',
  ...rest
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M6.39941 0C8.06719 1.4927 10.2604 2.41168 12.667 2.44434C12.7543 2.96481 12.7998 3.49963 12.7998 4.04492C12.7997 8.22474 10.128 11.7808 6.39941 13.0986C2.67101 11.7807 6.03603e-05 8.22462 0 4.04492C0 3.49962 0.0454646 2.96482 0.132812 2.44434C2.53936 2.41166 4.73167 1.49264 6.39941 0ZM9.2041 4.44043C8.98097 4.2174 8.61864 4.2174 8.39551 4.44043L5.59961 7.23633L4.4043 6.04102C4.18117 5.81789 3.81887 5.81796 3.5957 6.04102C3.3729 6.26413 3.37284 6.62556 3.5957 6.84863L5.19629 8.44922C5.30332 8.556 5.44842 8.61611 5.59961 8.61621C5.75096 8.61617 5.89681 8.55616 6.00391 8.44922L9.2041 5.24902C9.42713 5.02588 9.42715 4.66356 9.2041 4.44043Z"
        fill="currentColor"
      />
    </svg>
  );
}
